import React from 'react';
import './Panel.css';

const Panel = ({ title, children, style }) => (
  <section className="panel" style={style}>
    {title && <header className="panel-title">{title}</header>}
    <div className="panel-body">{children}</div>
  </section>
);

export default Panel; 